export class CreateScanModel {
    assetId = null;
    name = null;
    description = null;
    numberOfLenses = null;
    captureMethod = null;   // "Walkthrough" | "Drone" — captured for every scan (single + dual lens)
    createdBy = null;
    createdByUserId = null;
    uploadRequest = null;

    constructor(assetId, name, description, numberOfLenses, captureMethod, createdBy, createdByUserId, uploadRequest){
        this.assetId = assetId;
        this.name = name;
        this.description = description;
        this.numberOfLenses = numberOfLenses;
        this.captureMethod = captureMethod;
        this.createdBy = createdBy;
        this.createdByUserId = createdByUserId;
        this.uploadRequest = uploadRequest;
    }
}